import SvgIcon from '@mui/material/SvgIcon';
import {FC} from 'react';
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps {
    sx?: SxType
}

const DoubleArrowLeftIconSecondary: FC<IProps> = ({
                                         sx={}
                                     }) => {
    return (
        <SvgIcon
            sx={{

                width: '10px',
                height: '9px',
                fill: '#C4CED4',
                ...sx,
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 10 9"
            >
                <path
                    d="M4.472 8.734l-4-4.25 4-4.25.933.992-3.05 3.258 3.05 3.259-.933.991zm4.4 0l-4-4.25 4-4.25.933.992-3.05 3.258 3.05 3.259-.933.991z"
                ></path>
            </svg>
        </SvgIcon>
    );
};

export default DoubleArrowLeftIconSecondary;